<template>
  <div class="col-12">
    <div class="row">
      <div class="col-xxl-4 col-md-4 d-flex">
        <div class="card info-card summary-card w-100">
          <div class="card-body">
            <div class="summary-title">Доходы</div>
            <div class="summary-value text-success">{{ totalInfo.income }}</div>
          </div>
        </div>
      </div>

      <div class="col-xxl-4 col-md-4 d-flex">
        <div class="card info-card summary-card w-100">
          <div class="card-body">
            <div class="summary-title">Расходы</div>
            <div class="summary-value text-danger">{{ totalInfo.expense }}</div>
          </div>
        </div>
      </div>

      <div class="col-xxl-4 col-md-4 d-flex">
        <div class="card info-card summary-card w-100">
          <div class="card-body">
            <div class="summary-title">Итог</div>
            <div class="summary-value" :class="totalInfo.totalClass" >{{ totalInfo.totalSign }} {{ totalInfo.total }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <h5 class="card-title">{{ titleExpense }}</h5>

        <div class="row g-3 mt-3">

          <!-- График 1 -->
          <div class="col-12 col-lg-6">
            <div class="card h-100">
              <div class="card-body">
                <h6 class="card-title">Категории</h6>

                <DashboardChartDonut
                    v-if="card?.categories?.expense && card?.categories?.expense.length > 0"
                    :currency="card.currency"
                    :elements="card.categories.expense"
                />
                <span v-else>Нет данных</span>
              </div>
            </div>
          </div>

          <!-- График 2 -->
          <div class="col-12 col-lg-6">
            <div class="card h-100">
              <div class="card-body">
                <h6 class="card-title">Счета</h6>

                <DashboardBarChart
                    v-if="card?.accounts?.expense && card?.accounts?.expense.length > 0"
                    :currency="card.currency"
                    :elements="card.accounts.expense"
                />
                <span v-else>Нет данных</span>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">{{ titleIncome }}</h5>

        <div class="row g-3 mt-3">

          <!-- График 1 -->
          <div class="col-12 col-lg-6">
            <div class="card h-100">
              <div class="card-body">
                <h6 class="card-title">Категории</h6>

                <DashboardChartDonut
                    v-if="card?.categories?.expense && card?.categories?.income.length > 0"
                    :currency="card.currency"
                    :elements="card.categories.income"
                />
                <span v-else>Нет данных</span>
              </div>
            </div>
          </div>

          <!-- График 2 -->
          <div class="col-12 col-lg-6">
            <div class="card h-100">
              <div class="card-body">
                <h6 class="card-title">Счета</h6>

                <DashboardBarChart
                    v-if="card?.accounts?.expense && card?.accounts?.income.length > 0"
                    :currency="card.currency"
                    :elements="card.accounts.income"
                />
                <span v-else>Нет данных</span>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, reactive} from "vue";
import DashboardChartDonut from "@/features/dashboard/components/DashboardChartDonut.vue";
import DashboardBarChart from "@/features/dashboard/components/DashboardBarChart.vue";
import {getCurrencyFormatted, getCurrencySymbol} from "@/api/helpers";
const props = defineProps({
  titleIncome: String,
  titleExpense: String,
  card: {type: Object, required: false },
});

const totalInfo = computed(() => {
    const card = props.card;
    if (!card.currency) return {};
    const total = Number((card.income - card.expense).toFixed(2));
    return {
      income: getCurrencyFormatted(card.income, card.currency),
      expense: getCurrencyFormatted(card.expense, card.currency),
      total: getCurrencyFormatted(Math.abs(total), card.currency),
      totalSign: (total) >= 0 ? '+' : '-',
      totalClass: (total) >= 0 ? 'text-success' : 'text-danger',
    };
});

</script>

<style scoped>

</style>